// useTokenRefresh.ts
import { useEffect, useRef, useCallback } from 'react';
import { isTokenExpiringSoon, refreshToken, logout, getTokenRemainingMinutes } from '../config';

export const useTokenRefresh = (checkInterval: number = 60000) => {
  // checkInterval: كل كام ملي ثانية نتحقق (الافتراضي دقيقة)
  const intervalRef = useRef<NodeJS.Timeout | null>(null);
  const refreshingRef = useRef<boolean>(false);

  const checkAndRefreshToken = useCallback(async () => {
    // لو في عملية تحديث جارية، نSkip
    if (refreshingRef.current) return;

    // لو التوكن على وشك الانتهاء (خلال 10 دقائق)
    if (isTokenExpiringSoon(10)) {
      console.log(`🔄 التوكن على وشك الانتهاء، المتبقي: ${getTokenRemainingMinutes()} دقيقة`);
      
      refreshingRef.current = true;
      try {
        const success = await refreshToken();
        if (success) {
          console.log('✅ تم تحديث التوكن بنجاح');
        } else {
          console.log('❌ فشل تحديث التوكن، سيتم تسجيل الخروج');
          logout();
        }
      } catch (error) {
        console.error('❌ خطأ في تحديث التوكن:', error);
      } finally {
        refreshingRef.current = false;
      }
    }
  }, []);

  useEffect(() => {
    // نتحقق فوراً عند تحميل الصفحة
    checkAndRefreshToken();

    // نبدأ المؤقت للتحقق الدوري
    intervalRef.current = setInterval(checkAndRefreshToken, checkInterval);

    // تنظيف عند إلغاء التثبيت
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [checkAndRefreshToken, checkInterval]);
};